module.exports = __webpack_public_path__ + "static/img/content-box.e2c199e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/content-box.png
// module id = 82kc
// module chunks = 1